import OpuPlanner from '../../features/planning/layouts/opu-planner';

// TSS vite/01 §"Pages are thin".
export default function OpuPlanningPage() {
    return <OpuPlanner />;
}
